import React, { useState, useEffect, useCallback, useRef } from "react";
import { NavLink, Outlet, useLocation, Link } from "react-router-dom";
import {
  getFirestore,
  collection,
  getDocs,
  onSnapshot,
  doc,
  setDoc,
  getDoc,
  addDoc,
  query,
  where,
} from "firebase/firestore";
import ArrowRightIcon from "@untitled-ui/icons-react/build/esm/ArrowRight";
import Edit02Icon from "@untitled-ui/icons-react/build/esm/Edit02";
import XIcon from "@untitled-ui/icons-react/build/esm/X";
import { CalendarDaysIcon, HandRaisedIcon } from "@heroicons/react/24/outline";
import {
  Box,
  Button,
  Card,
  Container,
  Stack,
  SvgIcon,
  Typography,
  Tabs,
  DialogContent,
  Dialog,
  OutlinedInput,
  InputAdornment,
  TextField,
  Checkbox,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Avatar,
  Chip,
  Alert,
  AlertTitle,
  TablePagination,
  CardContent,
  Tooltip,
  Grid,
  MenuItem,
} from "@mui/material";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { Scrollbar } from "../../components/scrollbar";
import { useAuth } from "../../hooks/useAuth";
import { useNavigate } from "react-router-dom";
import PlusIcon from "@untitled-ui/icons-react/build/esm/Plus";
import ResumoIcon from "@untitled-ui/icons-react/build/esm/NotificationText";
import * as Yup from "yup";
import SearchMdIcon from "@untitled-ui/icons-react/build/esm/SearchMd";
import toast from "react-hot-toast";
import { SeverityPill } from "../../components/severity-pill";
import { format, addDays } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";
import { useFormik } from "formik";
import { LoadingButton } from "@mui/lab";

type Sessao = {
  id?: string;
  dataSessao: string; // Data da sessão
  legislatura: string; // Período da legislatura
  periodo: string; // Período da legislatura
  sessao: string; // Número da sessão
  numero: string; // Número da sessão
  statusConfigSessao: number; // Status de configuração da sessão
  statusSessao: string; // Status atual da sessão (ex.: "fechada")
  tipoSessao: string; // Tipo da sessão (ex.: "ordinária")
};

type User = {
  biografia: string; // Biografia do parlamentar
  cpf: string; // CPF do parlamentar
  email: string; // Email do parlamentar
  endereco: string; // Endereço do parlamentar
  enderecoGab: string; // Endereço do gabinete
  funcaoPartidaria: string; // Função partidária (ex.: vereador)
  imageP: string; // URL da imagem do perfil
  legislatura: string; // Informação sobre a legislatura
  nome: string; // Nome do parlamentar
  parlamentarEstado: string; // Estado do parlamentar (ex.: ativo)
  partido: string; // Partido ao qual o parlamentar pertence
  telefone: string; // Telefone do parlamentar
  telefoneGab: string; // Telefone do gabinete
  nomeParlamentar: string; // Apelido do parlamentar
};

export function Sessoes() {
  const [entidades, setEntidades] = useState([]);
  const [selected, setSelected] = useState([]);
  const [selectedPautasSessao, setSelectedPautasSessao] = useState([]);
  const [selectedAtasSessao, setSelectedAtasSessao] = useState([]);
  const [open, setOnOpen] = useState(false);
  const [pautasSessao, setPautasSessao] = useState([]);
  const [atas, setAtas] = useState([]);
  const [sessao, setSessoe] = useState({});
  const [loadingDuplSessao, setLoadingDuplSessao] = useState(false);
  const [codeSessao, setCodeSessao] = useState("");
  const [searchLegislatura, setSearchLegislatura] = useState("");
  const [searchStatus, setSearchStatus] = useState("");
  const [filteredData, setFilteredData] = useState([] as User[]);
  const [searchName, setSearchName] = useState("");

  const navigate = useNavigate();

  const legislaturaOptions = [
    {
      label: "Legislatura (2025) - (2028)",
      value: "2025-2028",
    },
    {
      label: "Legislatura (2021) - (2024)",
      value: "2021-2024",
    },
    {
      label: "Legislatura (2017) - (2020)",
      value: "2017-2020",
    },
  ];

  useEffect(() => {
    const db = getFirestore();
    const auth = getAuth();

    const ordersRef = collection(db, "users", "belacruz@eleg", "sessoes");
    // const queryRef = query(ordersRef, where("legislatura", "==", "2025-2028"));
    onSnapshot(ordersRef, (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();
        // Cria um objeto com as propriedades e seus respectivos valores
        const obj = {
          id: doc.id,
          dataSessao: data.dataSessao,
          ...data,

          // Adicione outras propriedades e seus valores aqui, se necessário
        };
        return obj;
      });

      // Ordenar os dados com base na propriedade 'dataSessao'
      parsedData.sort((a, b) => {
        // Converta as datas para objetos Date para que a ordenação funcione corretamente
        const dateA = new Date(a.dataSessao);
        const dateB = new Date(b.dataSessao);

        //@ts-ignore
        return dateB - dateA;
      });

      //@ts-ignore
      setEntidades(parsedData);
    });
  }, []);

  useEffect(() => {
    if (searchStatus === "") {
      setSearchStatus(legislaturaOptions[0].value);
    }
    if (searchLegislatura === "") {
      setSearchLegislatura(legislaturaOptions[0].value);
    }

    const filtered = entidades.filter((item) => {
      const isNameMatch =
        !searchName ||
        //@ts-ignore
        item.numero?.toLowerCase().includes(searchName.toLowerCase());
      const isLegislaturaMatch =
        //@ts-ignore
        !searchLegislatura || item.legislatura?.includes(searchLegislatura);

      return isNameMatch && isLegislaturaMatch;
    });

    setFilteredData(filtered);
  }, [entidades, searchName, searchLegislatura, searchStatus]);

  const useSearch = () => {
    const [search, setSearch] = useState({
      filters: {
        query: undefined,
        hasAcceptedMarketing: undefined,
        isProspect: undefined,
        isReturning: undefined,
      },
      page: 0,
      rowsPerPage: 5,
      sortBy: "updatedAt",
      sortDir: "desc",
    });

    return {
      search,
      updateSearch: setSearch,
    };
  };

  const { search, updateSearch } = useSearch();

  const handlePageChange = useCallback(
    (event: any, page: any) => {
      updateSearch((prevState) => ({
        ...prevState,
        page,
      }));
    },
    [updateSearch]
  );

  const handleRowsPerPageChange = useCallback(
    (event: any) => {
      updateSearch((prevState) => ({
        ...prevState,
        rowsPerPage: parseInt(event.target.value, 10),
      }));
    },
    [updateSearch]
  );

  //@ts-ignore
  const selectOne = useCallback((customerId) => {
    //@ts-ignore
    setSelected([customerId]);
  }, []);

  //@ts-ignore
  const deselectOne = useCallback((customerId) => {
    setSelected((prevState) => {
      return prevState.filter((id) => id !== customerId);
    });
  }, []);

  const tipoSessaoOptions = [
    {
      label: "Extraordinária",
      value: "extraordinaria ",
    },
    {
      label: "Ordinária",
      value: "ordinaria",
    },
  ];

  const formik = useFormik({
    initialValues: {
      legislatura: "",
      sessao: "",
      tipoSessao: "",
      statusSessao: "",
      dataSessao: "",
      submit: null,
    },
    validationSchema: Yup.object({
      legislatura: Yup.string().max(255).required("O campo é obrigatório"),
      sessao: Yup.string().max(255).required("O campo é obrigatório"),
      tipoSessao: Yup.string().max(255),
      dataSessao: Yup.string().max(255),
      idPauta: Yup.string(),
      tituloAtaExpediente: Yup.string().max(255),
      textoAta: Yup.string(),
    }),
    onSubmit: async (values, helpers) => {
      setLoadingDuplSessao(!loadingDuplSessao);
      const db = getFirestore();
      const colecaoPaiRef = collection(db, "users");
      const novoDocumentoRef = doc(colecaoPaiRef, "belacruz@eleg");
      const subcolecaoRef = collection(novoDocumentoRef, "sessoes");
      const novoDocumentocCdeSessaoRef = doc(subcolecaoRef, codeSessao);

      setDoc(novoDocumentocCdeSessaoRef, {
        legislatura:
          values.legislatura !== undefined ? values.legislatura : undefined,
        sessao: values.sessao !== undefined ? values.sessao : undefined,
        tipoSessao:
          values.tipoSessao !== undefined ? values.tipoSessao : undefined,
        dataSessao:
          values.dataSessao !== undefined
            ? format(addDays(new Date(values.dataSessao), 1), "yyyy-MM-dd")
            : undefined,
        statusSessao: "rascunho",
        hibridaSessao: true,
        statusConfigSessao: 1,
      }).then(async () => {
        await Promise.all(
          selectedPautasSessao.map(async (idDocSnapshot) => {
            const db = getFirestore();

            //@ts-ignore
            const docRef = doc(
              db,
              "users",
              `belacruz@eleg`,
              "sessoes",
              `${selected[0]}`,
              "pautas",
              idDocSnapshot
            );
            const docSnap = await getDoc(docRef);

            const colecaoPaiRef = collection(db, "users");
            const novoDocumentoRef = doc(colecaoPaiRef, "belacruz@eleg");
            const subcolecaoSessaoRef = collection(novoDocumentoRef, "sessoes");
            //@ts-ignore
            const novoDocumentoCodeSessao = doc(
              subcolecaoSessaoRef,
              codeSessao
            );
            const subcolecaoPautaRef = collection(
              novoDocumentoCodeSessao,
              "pautas"
            );

            addDoc(subcolecaoPautaRef, {
              idPauta: idDocSnapshot,
              votado: false,
              //@ts-ignore
              numero: docSnap.data().numero,
              //@ts-ignore
              expressoes: docSnap.data().expressoes,
              leituraVis: false,
            });
          })
        );

        await Promise.all(
          selectedAtasSessao.map(async (idDocSnapshot) => {
            const db = getFirestore();

            //@ts-ignore
            const docRef = doc(
              db,
              "users",
              `belacruz@eleg`,
              "sessoes",
              `${selected[0]}`,
              "atas",
              idDocSnapshot
            );
            const docSnap = await getDoc(docRef);

            const colecaoPaiRef = collection(db, "users");
            const novoDocumentoRef = doc(colecaoPaiRef, "belacruz@eleg");
            const subcolecaoSessaoRef = collection(novoDocumentoRef, "sessoes");
            //@ts-ignore
            const novoDocumentoCodeSessao = doc(
              subcolecaoSessaoRef,
              codeSessao
            );
            const subcolecaoPautaRef = collection(
              novoDocumentoCodeSessao,
              "atas"
            );

            addDoc(subcolecaoPautaRef, {
              //@ts-ignore
              textoAta: docSnap.data().textoAta,
              //@ts-ignore
              tituloAtaExpediente: docSnap.data().tituloAtaExpediente,
            });
          })
        );

        helpers.setStatus({ success: true });
        helpers.setSubmitting(false);
        toast.success("Customer updated");
        setLoadingDuplSessao(!loadingDuplSessao);
        setOnOpen(!open);
        setSelected([]);
      });
    },
  });

  const selectedAll = selected.length === entidades.length;
  const selectedSome =
    selected.length > 0 && selected.length < entidades.length;
  const enableBulkActions = selected.length > 0;

  const paginatedData = filteredData.slice(
    search.page * search.rowsPerPage,
    (search.page + 1) * search.rowsPerPage
  );

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 3,
      }}
    >
      <Dialog fullWidth maxWidth="md" open={open}>
        <Stack spacing={4}>
          <DialogContent>
            <form onSubmit={formik.handleSubmit}>
              <Stack
                alignItems="center"
                direction="row"
                justifyContent="space-between"
                sx={{
                  px: 3,
                  pt: 1,
                  mb: 2,
                }}
              >
                <Typography variant="h5">
                  {/* @ts-ignore */}
                  Duplicar Sessão {sessao.sessao}
                </Typography>

                <IconButton
                  color="inherit"
                  onClick={() => {
                    setOnOpen(!open);
                  }}
                >
                  <SvgIcon>
                    <XIcon />
                  </SvgIcon>
                </IconButton>
              </Stack>
              <Card>
                <CardContent
                  sx={{
                    mb: 2,
                  }}
                >
                  <Grid container justifyContent="space-between">
                    <Grid item marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(
                            formik.touched.legislatura &&
                            formik.errors.legislatura
                          )
                        }
                        fullWidth
                        label="Legislatura"
                        name="legislatura"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        select
                        value={formik.values.legislatura}
                      >
                        {legislaturaOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(formik.touched.sessao && formik.errors.sessao)
                        }
                        fullWidth
                        helperText={
                          formik.touched.sessao && formik.errors.sessao
                        }
                        label="Sessão"
                        name="sessao"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.sessao}
                      />
                    </Grid>
                    <Grid item marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(
                            formik.touched.tipoSessao &&
                            formik.errors.tipoSessao
                          )
                        }
                        fullWidth
                        label="Tipo Sessão"
                        name="tipoSessao"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        select
                        value={formik.values.tipoSessao}
                      >
                        {tipoSessaoOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item marginTop={3} xs={12} md={5.85}>
                      <TextField
                        error={
                          !!(
                            formik.touched.dataSessao &&
                            formik.errors.dataSessao
                          )
                        }
                        fullWidth
                        helperText={
                          formik.touched.dataSessao && formik.errors.dataSessao
                        }
                        label="Data da Sessão"
                        name="dataSessao"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.dataSessao}
                        type={"date"}
                      />
                    </Grid>
                  </Grid>
                </CardContent>

                <Card
                  sx={{
                    mt: 2,
                    mx: 3,
                  }}
                >
                  <CardContent
                    sx={{
                      padding: 0,
                      mb: 1,
                    }}
                  >
                    <Scrollbar>
                      <Table sx={{ minWidth: 600 }}>
                        <TableHead>
                          <TableRow>
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={false}
                                disabled={true}
                                sx={{
                                  opacity: 0,
                                }}
                              />
                            </TableCell>
                            <TableCell>Número</TableCell>
                            <TableCell>Tipo da pauta legislativa</TableCell>
                            <TableCell align="right">Ações</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {pautasSessao !== undefined &&
                            pautasSessao.map((item) => {
                              const isSelected = selectedPautasSessao.includes(
                                //@ts-ignore
                                item.id
                              );

                              return (
                                <TableRow
                                  //@ts-ignore
                                  key={item.id}
                                >
                                  <TableCell padding="checkbox">
                                    <Checkbox
                                      checked={isSelected}
                                      onChange={(event) => {
                                        const { checked } = event.target;

                                        if (checked) {
                                          setSelectedPautasSessao(
                                            //@ts-ignore
                                            (prevState: any) => [
                                              ...prevState,
                                              //@ts-ignore
                                              item.id,
                                            ]
                                          );
                                        } else {
                                          setSelectedPautasSessao(
                                            (prevState) => {
                                              return prevState.filter(
                                                //@ts-ignore
                                                (id) => id !== item.id
                                              );
                                            }
                                          );
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <Typography variant="subtitle1">
                                      {/*@ts-ignore*/}
                                      {item.numero}
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    {/*@ts-ignore*/}
                                    {item.pautaLegislativa}
                                  </TableCell>
                                  <TableCell align="right">
                                    <IconButton
                                      onClick={() => {
                                        //@ts-ignore
                                        navigate(`/sessoes/${item.id}`);
                                      }}
                                    >
                                      <Tooltip title="Editar">
                                        <SvgIcon>
                                          <Edit02Icon />
                                        </SvgIcon>
                                      </Tooltip>
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </Scrollbar>
                  </CardContent>
                </Card>
                <Card
                  sx={{
                    mt: 2,
                    mx: 3,
                  }}
                >
                  <CardContent
                    sx={{
                      padding: 0,
                    }}
                  >
                    <Scrollbar>
                      <Table sx={{ minWidth: 600 }}>
                        <TableHead>
                          <TableRow>
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={false}
                                disabled={true}
                                sx={{
                                  opacity: 0,
                                }}
                              />
                            </TableCell>
                            <TableCell>Título</TableCell>
                            <TableCell>Texto da Ata</TableCell>
                            <TableCell align="right">Ações</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {atas !== undefined &&
                            atas.map((item) => {
                              //@ts-ignore
                              function removeTags(textoHTML) {
                                const div = document.createElement("div");
                                div.innerHTML = textoHTML;
                                return div.textContent || div.innerText || "";
                              }

                              const isSelected = selectedAtasSessao.includes(
                                //@ts-ignore
                                item.id
                              );

                              return (
                                <TableRow
                                  //@ts-ignore
                                  key={item.id}
                                >
                                  <TableCell padding="checkbox">
                                    <Checkbox
                                      checked={isSelected}
                                      onChange={(event) => {
                                        const { checked } = event.target;

                                        if (checked) {
                                          //@ts-ignore
                                          setSelectedAtasSessao((prevState) => [
                                            ...prevState,
                                            //@ts-ignore
                                            item.id,
                                          ]);
                                        } else {
                                          setSelectedAtasSessao((prevState) => {
                                            //@ts-ignore
                                            return prevState.filter(
                                              //@ts-ignore
                                              (id) => id !== item.id
                                            );
                                          });
                                        }
                                      }}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    <Typography variant="subtitle1">
                                      {/*@ts-ignore*/}
                                      {item.tituloAtaExpediente}
                                    </Typography>
                                  </TableCell>
                                  <TableCell>
                                    {/*@ts-ignore*/}
                                    {removeTags(item.textoAta)}
                                  </TableCell>
                                  <TableCell align="right">
                                    <IconButton
                                      onClick={() => {
                                        //@ts-ignore
                                        navigate(`/sessoes/${item.id}`);
                                      }}
                                    >
                                      <Tooltip title="Editar">
                                        <SvgIcon>
                                          <Edit02Icon />
                                        </SvgIcon>
                                      </Tooltip>
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </Scrollbar>
                  </CardContent>
                </Card>
              </Card>

              <Stack
                direction={{
                  xs: "column",
                  sm: "row",
                }}
                flexWrap="wrap"
                spacing={3}
                sx={{ p: 3 }}
              >
                <LoadingButton
                  loading={loadingDuplSessao}
                  disabled={formik.isSubmitting}
                  type="submit"
                  variant="contained"
                >
                  Cadastrar
                </LoadingButton>
                <Button
                  color="inherit"
                  onClick={() => {
                    setOnOpen(!open);
                  }}
                  disabled={formik.isSubmitting}
                >
                  Cancelar
                </Button>
              </Stack>
            </form>
          </DialogContent>
        </Stack>
      </Dialog>

      <Container
        maxWidth="xl"
        sx={{
          mt: 3,
        }}
      >
        <Stack spacing={4}>
          <Stack direction="row" justifyContent="space-between" spacing={4}>
            <Stack spacing={1}>
              <Typography variant="h4">Sessões Plenárias</Typography>
            </Stack>
            <Stack alignItems="center" direction="row" spacing={3}>
              <NavLink to="/sessoes/cadastro">
                <Button
                  startIcon={
                    <SvgIcon>
                      <PlusIcon />
                    </SvgIcon>
                  }
                  variant="contained"
                >
                  Adicionar
                </Button>
              </NavLink>
            </Stack>
          </Stack>

          <Card>
            <div className="relative isolate overflow-hidden bg-gray-900 py-16 sm:py-24 lg:py-12">
              <div className="flex items-center justify-center mx-auto max-w-7xl px-6 lg:px-8">
                <div className="w-screen mr-20">
                  <h5 className="text-1xl font-bold tracking-tight text-white sm:text-2xl">
                    Agora temos o resumo da Sessão Plenária
                  </h5>
                  <p className="mt-4 leading-6 text-gray-300">
                    Fique por dentro das decisões e debates mais importantes! O
                    resumo da Sessão Plenária oferece uma visão geral completa
                    dos acontecimentos.
                  </p>
                </div>
              </div>
              <div
                className="absolute left-1/2 top-0 -z-10 -translate-x-1/2 blur-3xl xl:-top-6"
                aria-hidden="true"
              >
                <div
                  className="aspect-[1155/678] w-[72.1875rem] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30"
                  style={{
                    clipPath:
                      "polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)",
                  }}
                />
              </div>
            </div>
          </Card>

          <Card>
            <Stack
              alignItems="center"
              direction="row"
              flexWrap="wrap"
              spacing={3}
              sx={{ p: 3 }}
            >
              <Box component="form" sx={{ flexGrow: 1 }}>
                <OutlinedInput
                  defaultValue=""
                  fullWidth
                  placeholder="Procure por um número de sessão..."
                  onChange={(e) => setSearchName(e.target.value)}
                  startAdornment={
                    <InputAdornment position="start">
                      <SvgIcon>
                        <SearchMdIcon />
                      </SvgIcon>
                    </InputAdornment>
                  }
                />
              </Box>
              <TextField
                label="Legislatura"
                name="sort"
                select
                SelectProps={{ native: true }}
                onChange={(e) => setSearchLegislatura(e.target.value)}
              >
                {legislaturaOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
            </Stack>

            <Box sx={{ position: "relative" }}>
              {enableBulkActions && (
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    alignItems: "center",
                    backgroundColor: (theme) =>
                      theme.palette.mode === "dark"
                        ? "neutral.800"
                        : "neutral.50",
                    display: enableBulkActions ? "flex" : "none",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    px: 2,
                    py: 0.5,
                    zIndex: 10,
                  }}
                >
                  <Checkbox
                    checked={selectedAll}
                    indeterminate={selectedSome}
                  />
                  <Button
                    color="inherit"
                    size="small"
                    onClick={() => {
                      setOnOpen(!open);

                      const db = getFirestore();

                      //@ts-ignore
                      const ordersRef = collection(
                        db,
                        "users",
                        "belacruz@eleg",
                        "sessoes",
                        `${selected[0]}`,
                        "pautas"
                      );

                      getDocs(ordersRef).then((docSnapshot) => {
                        const parsedData = docSnapshot.docs.map((doc) => {
                          const data = doc.data();

                          //@ts-ignore
                          setSelectedPautasSessao((prevState) => [
                            ...prevState,
                            doc.id,
                          ]);

                          return { id: doc.id, ...data };
                        });

                        //@ts-ignore
                        setPautasSessao(parsedData);
                      });

                      const ordersRefAtas = collection(
                        db,
                        "users",
                        `belacruz@eleg`,
                        "sessoes",
                        `${selected[0]}`,
                        "atas"
                      );

                      getDocs(ordersRefAtas)
                        .then((querySnapshot) => {
                          const parsedData = querySnapshot.docs.map((doc) => {
                            const data = doc.data();

                            //@ts-ignore
                            setSelectedAtasSessao((prevState) => [
                              ...prevState,
                              doc.id,
                            ]);
                            // Cria um objeto com as propriedades e seus respectivos valores
                            const obj = {
                              id: doc.id,
                              textoAta: data.textoAta,
                              tituloAtaExpediente: data.tituloAtaExpediente,
                              // Adicione outras propriedades e seus valores aqui, se necessário
                            };
                            return obj;
                          });

                          //@ts-ignore
                          setAtas(parsedData);
                        })
                        .catch((error) => {
                          console.log(
                            "Erro ao recuperar dados da subcoleção:",
                            error
                          );
                        });

                      const ordersRefSessao = doc(
                        db,
                        "users",
                        "belacruz@eleg",
                        "sessoes",
                        `${selected[0]}`
                      );

                      getDoc(ordersRefSessao)
                        .then((docSnapshot) => {
                          if (docSnapshot.exists()) {
                            const data = docSnapshot.data();

                            formik.setValues({
                              legislatura: data.legislatura,
                              sessao: data.sessao,
                              tipoSessao: data.tipoSessao,
                              statusSessao: data.statusSessao,
                              dataSessao: data.dataSessao,
                              submit: null,
                            });

                            setSessoe({ data });
                          } else {
                            console.log("Documento não encontrado");
                          }
                        })
                        .catch((error) => {
                          console.log(
                            "Erro ao recuperar dados do documento:",
                            error
                          );
                        });

                      const characters =
                        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
                      let code = "";

                      for (let i = 0; i < 20; i++) {
                        const randomIndex = Math.floor(
                          Math.random() * characters.length
                        );
                        code += characters.charAt(randomIndex);
                      }

                      setCodeSessao(code);
                    }}
                  >
                    Duplicar
                  </Button>
                  <Button
                    color="inherit"
                    size="small"
                    onClick={() => {
                      //@ts-ignore
                      navigate(`/sessoes/${selected[0]}/vis`);
                    }}
                  >
                    Editar
                  </Button>
                </Stack>
              )}
              <Scrollbar>
                <Table sx={{ minWidth: 700 }}>
                  <TableHead>
                    <TableRow>
                      <TableCell padding="checkbox">
                        <Checkbox checked={false} />
                      </TableCell>
                      <TableCell>Sessão</TableCell>
                      <TableCell>Legislatura</TableCell>
                      <TableCell>Data</TableCell>
                      <TableCell align="left">Status</TableCell>
                      <TableCell align="right">Ações</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {paginatedData !== undefined &&
                      //@ts-ignore
                      paginatedData.map((item: Sessao, index) => {
                        //@ts-ignore
                        const isSelected = selected.includes(item.id);
                        //@ts-ignore
                        const statusColorMap: Record<string, string> = {
                          rascunho: "warning",
                          aberta: "success",
                          fechada: "error",
                        };
                        const statusColor =
                          statusColorMap[item.statusSessao] || "info";
                        //@ts-ignore
                        const statusLabel =
                          item.statusSessao || "não informado";
                        //@ts-ignore
                        const legislaturaSessao =
                          (item.legislatura === "2025-2028" &&
                            "Legislatura (2025) - (2028)") ||
                          (item.legislatura === "2021-2024" &&
                            "Legislatura (2021) - (2024)") ||
                          (item.legislatura == "" && "Não informado");
                        //@ts-ignore
                        const dataSessao = format(
                          addDays(new Date(item.dataSessao), 1),
                          "dd 'de' MMM",
                          { locale: ptBR }
                        );
                        //@ts-ignore
                        const valueSessao =
                          item.sessao === "" ? "Não informado" : item.sessao;

                        return (
                          <TableRow
                            hover
                            key={index}
                            sx={{
                              //@ts-ignore
                              cursor: "pointer",
                            }}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                checked={isSelected}
                                //@ts-ignore
                                disabled={
                                  item.statusSessao != "fechada" ? false : true
                                }
                                sx={{
                                  //@ts-ignore
                                  opacity:
                                    item.statusSessao != "fechada" ? 1 : 0.4,
                                }}
                                onChange={(event) => {
                                  const { checked } = event.target;

                                  if (checked) {
                                    //@ts-ignore
                                    selectOne(item.id);
                                  } else {
                                    //@ts-ignore
                                    deselectOne(item.id);
                                  }
                                }}
                                value={isSelected}
                              />
                            </TableCell>
                            <TableCell>
                              {
                                //@ts-ignore
                                item.sessao === "" ? (
                                  <Chip label={valueSessao} size="small" />
                                ) : (
                                  //@ts-ignore
                                  valueSessao
                                )
                              }
                            </TableCell>
                            <TableCell>
                              {
                                //@ts-ignore
                                item.legislatura == "" ? (
                                  <Chip
                                    label={legislaturaSessao}
                                    size="small"
                                  />
                                ) : (
                                  `${legislaturaSessao}`
                                )
                              }
                            </TableCell>
                            <TableCell>
                              {/*@ts-ignore*/}
                              {dataSessao}
                            </TableCell>
                            <TableCell>
                              {/*@ts-ignore*/}
                              <SeverityPill color={statusColor}>
                                {statusLabel}
                              </SeverityPill>
                            </TableCell>

                            <TableCell align="right">
                              {
                                //@ts-ignore
                                item.statusSessao == "fechada" ? (
                                  //@ts-ignore
                                  <Link
                                    to={`/sessoes/${item.id}/resumo`}
                                    className="text-sm font-semibold text-gray-900 hover:underline"
                                  >
                                    Resumo da Sessão
                                  </Link>
                                ) : null
                              }

                              <IconButton
                                onClick={() => {
                                  //@ts-ignore
                                  navigate(`/sessoes/${item.id}/vis`);
                                }}
                                style={{
                                  marginLeft: 15,
                                }}
                              >
                                <SvgIcon>
                                  <ArrowRightIcon />
                                </SvgIcon>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </Scrollbar>

              <TablePagination
                component="div"
                count={filteredData.length}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
                page={search.page}
                rowsPerPage={search.rowsPerPage}
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage="Linhas por página"
                labelDisplayedRows={({ from, to, count }) =>
                  `${from}-${to} de ${count}`
                }
              />
            </Box>
          </Card>
        </Stack>
      </Container>
    </Box>
  );
}
